import {
	Box,
	Divider,
	Drawer,
	Stack,
	Step,
	Button,
	StepButton,
	StepContent,
	StepLabel,
	Stepper,
	Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomStepComponent from './CustomStepComponent';
import { AppColors } from '../../../Utils/helper/AppColors';
import CampaignUsers from './CampaignSteps/CampaignUsers';
import BasicDetails from './CampaignSteps/BasicDetails';
import Scheduling from './CampaignSteps/Scheduling';
import VoiceAndTone from './CampaignSteps/VoiceAndTone';
import CampaignEmail from './CampaignSteps/CampaignEmail';
import CampaignQuestions from './CampaignSteps/CampaignQuestions';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../../Routes/Pathname';
import CultService from '../../../Services/CultService';
// import { Button } from 'antd';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../../Utils/helper/HelperTexts';
import { useSelector } from 'react-redux';
import { CAMPAIGN_STATUS, DATE_CONDITIONS_key_map, FILTER_OPTIONS_key_map } from '../../../Utils/helper/AppConstants';
import CampaignConversationType from './CampaignSteps/CampaignConversationType';
import CampaignPreview from './CampaignSteps/CampaignPreview';
import IconContainer from '../../../Components/IconContainer';
import { RiFlagLine } from 'react-icons/ri';
import { CloseIcon } from '../../../Components/Icons/Icons';
import dayjs from 'dayjs';
import { ConfirmationDialog }from '../../../Components/ConfirmationDialog'

const EMAIL_SUBJECT =
	'Your Voice Matters: Speak Freely with Addie — Our New AI Agent for Inclusive Communication--Schedule a conversation now';

export default function CreateEditCampaign(props) {
	const { edit, isNewCampaign = false, setOpen = {}, fetch, campaignData = null } = props;
	const navigate = useNavigate();
	const location = useLocation();
	const selected = location?.state?.campaign;
	const campaignCopy = location?.state?.campaign?.copy ? 'copy' : null;
	const isCampaignTypeExitInterview = location?.state?.isExitInterviewCampaign || false;

	const [loading, setLoading] = useState(false);
	const [assistants, setAssistants] = useState([]);

	const [isDialogOpenCheckData, setIsDialogOpenCheckData] = useState(null);  // null or {{ "filterType": "timezone", "condition": null, "value": "America/Tijuana" }}
	const [isDialogOpen, setIsDialogOpen] = useState(false);  // can be step number (1 - 6) || false
	// console.log('isDialogOpen in <CreateEditCampaign>', isDialogOpen);
	const steps = [
		{
			label: 'Basic Details',
			description: 'Please enter  basic details for identification and further processing.',
			Component: BasicDetails,
		},
		{ label: 'Scheduling', description: 'Select your preferred date and time to schedule the campaign.', Component: Scheduling },
		// { label: 'Voice & tone',  Component: VoiceAndTone },
		{ label: 'Users', description: 'Select a user from the list to send a campaign.', Component: CampaignUsers },
		{ label: 'Email', description: 'Provide a subject line and compose the body of the email.', Component: CampaignEmail },
		// { label: 'Questions',  Component: CampaignQuestions },
		{ label: 'Conversation Type', description: 'Select the model as per your requirement', Component: CampaignConversationType , props: { exitInterView: isCampaignTypeExitInterview, setAssistants } },
		{ label: 'Preview', description: 'Review the campaign details before sending.', Component: CampaignPreview },
	];

	const [activeIndex, setActiveIndex] = useState(0);

	const [details, setDetails] = useState({});
	const company = useSelector((state) => state?.app?.company);

	const checkValidation = () => {
		switch (true) {
			case !details?.basicDetails:
			case !details?.basicDetails?.name:
				return '0';
			case !details?.scheduling:
			case !details?.scheduling?.startDate:
			case !details?.scheduling?.endDate:
			case !details?.scheduling?.startTime:
			case !details?.scheduling?.endTime:
			case !details?.scheduling?.maxTry:
				return '1';
			case details?.advancedOptionsEnabled &&
				!details?.advancedOptions?.recurrence?.customDays &&
				!details?.advancedOptions?.recurrence?.type:
				return '5';
			case details?.advancedOptionsEnabled &&
				!(
					details?.advancedOptions?.filters?.department?.value?.length > 0 ||
					(details?.advancedOptions?.filters?.dateOfJoining?.before || details?.advancedOptions?.filters?.dateOfJoining?.after) ||
					(details?.advancedOptions?.filters?.dateOfRelieving?.before || details?.advancedOptions?.filters?.dateOfRelieving?.after) ||
					details?.advancedOptions?.filters?.timezone?.value?.length > 0 ||
					!!details?.advancedOptions?.filters?.source?.value 
				):
				return '6';
			case !details?.users:
			case details?.users?.length === 0:
				return '2';
			case !details?.assistantId:
				return '4';
			default:
				return 'success';
		}
	};

	const handleValidationErrors = (err) => {
		const errorMessages = {
			0: { message: 'Please fill required Basic Details for this campaign', index: 0 },
			1: { message: 'Please fill required Scheduling details for this campaign', index: 1 },
			2: { message: 'Please Select at least one Employee for this campaign', index: 2 },
			4: { message: 'Please select the Model for this campaign', index: 4 },
			5: {
				message: 'Please enter the number of custom days in Recurrence Schedule or we will set it to default Daily type',
				index: 1,
			},
			6: {
				message: 'Please select at least one filter in Advanced Options',
				index: 1,
			}
		};

		if (errorMessages[err]) {
			toast.error(errorMessages[err].message);
			setActiveIndex(errorMessages[err].index);
			return true; // Validation error found
		}
		return false; // No validation errors
	};

	const handleCreateCampaign = async (status = CAMPAIGN_STATUS.live.code, isDraft = false) => {
		setLoading(true);

		try {
			// check for errors before creating campaign
			if (!isDraft) {
				let err = checkValidation();
				if (handleValidationErrors(err)) return;
			}

			const res = await CultService.createCampaign({ data: { ...details, status, companyId: company?._id } });
			if (res.status == 200) {
				if (!isDraft) {
					// setOpen(false);
					// navigate(PATH_NAME.CAMPAIGN_LIST);
					navigate(PATH_NAME.CAMPAIGN_LIST, { state: { createdNewCampignSuccesfully: true } });

					// fetch();
				} else {
					// setOpen(false);
					// navigate(PATH_NAME.CAMPAIGN_LIST);
					navigate(-1);

					// fetch();
				}
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const handleUpdateCampaign = async (status = CAMPAIGN_STATUS.live.code, isDraft = false) => {
		try {
			if (!isDraft) {
				let err = checkValidation();
				if (handleValidationErrors(err)) return;
			}

			const res = await CultService.updateCampaign({
				params: { id: selected?._id },
				data: { ...details, status },
			});
			if (res.status == 200) {
				// setOpen(false);
				navigate(-1);
				// fetch();
			}
		} catch (err) {
			toast.error(err?.response?.data?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const handleCancel = () => {
		if (edit) {
			// navigate(PATH_NAME.CAMPAIGN_LIST);
			navigate(-1);

			// setOpen(false);
		} else {
			navigate(-1);
			// setOpen(false);
		}
	};

	const handlePrev = () => {
		if (activeIndex > 0) {
			if(handleOpenDialogValidationCheck()){
				setIsDialogOpen(activeIndex);
				return;
			}
			setActiveIndex(activeIndex - 1);
		} else handleCancel();
	};

	const handleOpenDialogValidationCheck = () => {
		return details?.advancedOptionsEnabled  && !isDialogOpen &&  (activeIndex === 1 && isDialogOpenCheckData !== null);
	};

	const handleNext = () => {
		if (activeIndex < steps.length - 1) {
			if(handleOpenDialogValidationCheck()){
			setIsDialogOpen(activeIndex + 2);
			return;
		}
			setActiveIndex(activeIndex + 1);
		} else {
			if (edit && campaignCopy !== 'copy') {
				handleUpdateCampaign();
			} else {
				handleCreateCampaign();
			}
		}
	};

	const handleStep = (step) => {
        console.log('sss' , step);
		if(handleOpenDialogValidationCheck()){
			setIsDialogOpen(step + 1);
			return;
		}
		setActiveIndex(step);
	};

	const handleDraft = (isDraft = false) => {
		if (edit && campaignCopy !== 'copy') {
			handleUpdateCampaign(CAMPAIGN_STATUS.draft.code, isDraft);
		} else {
			handleCreateCampaign(CAMPAIGN_STATUS.draft.code, isDraft);
		}
	};

	useEffect(() => {
		if (selected || isNewCampaign) {
			// Check if either startDate or endDate is before today
			let scheduling = selected?.scheduling || {};
			const today = dayjs().startOf('day');
			const startDate = scheduling.startDate ? dayjs(scheduling.startDate, 'YYYY-MM-DD') : null;
			const endDate = scheduling.endDate ? dayjs(scheduling.endDate, 'YYYY-MM-DD') : null;

			// If either date is before today, set both to null
			if ((startDate && startDate.isBefore(today, 'day')) || (endDate && endDate.isBefore(today, 'day'))) {
				scheduling = { ...scheduling, startDate: null, endDate: null };
			}

			if (selected?.type === '1' || selected?.type === '2') {
				setDetails((prevDetails) => ({
					...prevDetails,
					...selected,
					scheduling,
					email: edit ? { ...selected?.email } : { ...selected?.email, subject: selected?.email?.subject || EMAIL_SUBJECT },
				}));
			} else {
				const users = selected?.compaignUser?.map((i) => i?.userId?._id);
				setDetails((prevDetails) => ({
					...prevDetails,
					...selected,
					scheduling,
					users,
					email: edit ? { ...selected?.email } : { ...selected?.email, subject: selected?.email?.subject || EMAIL_SUBJECT },
				}));
			}
		}
	}, [JSON.stringify(selected)]);

	// useEffect(() => {

	// }, [selected]);

	// const isDisabled = () => {
	// 	let res = false;
	// 	if (activeIndex == steps.length - 1) {
	// 		if (

	// 			!details?.basicDetails ||
	// 			!details?.basicDetails?.name ||
	// 			!details?.scheduling ||
	// 			!details?.scheduling?.startDate ||
	// 			!details?.scheduling?.endDate ||
	// 			!details?.scheduling?.startTime ||
	// 			!details?.scheduling?.endTime ||
	// 			!details?.scheduling?.maxTry ||
	// 			!details?.scheduling?.maxTryPerDay ||
	// 			!details?.scheduling?.endTime ||
	// 			!details?.users ||
	// 			details?.users?.length == 0 ||
	// 		    !details?.assistantId
	// 		) {
	// 			res = true;
	// 		}
	// 	}
	// 	return res;
	// };

	const isDisabledDraft = () => {
		let res = false;
		if (!details?.basicDetails?.name) {
			res = true;
		}
		return res;
	};
function buildRuleSubtitle({ filterType, condition, value }) {
  const filterTypeLabel = filterType ? `<span style="font-weight: bold;">${FILTER_OPTIONS_key_map?.[filterType]}</span>` : '';
  const conditionLabel = condition ? `<span style="font-weight: bold;">${DATE_CONDITIONS_key_map?.[condition]}</span>` : '';
  let valueLabel = '';

  if (value) {
    if (Array.isArray(value)) {
      // Filter out null/undefined and join non-empty values
      const filtered = value.filter(v => v !== null && v !== undefined && v !== '');
      valueLabel = filtered.length > 0
        ? `<span style="font-weight: bold;">${filtered.join(', ')}</span>`
        : '';
    } else if (value !== null && value !== undefined && value !== '') {
      valueLabel = `<span style="font-weight: bold;">${value}</span>`;
    }
  }

  // Collect non-empty labels
  const parts = [filterTypeLabel, conditionLabel, valueLabel].filter(Boolean);

  // Join with ' - ' only if there are multiple parts
  const ruleSummary = parts.join(' - ');

  return `You Didn't Added Rule ${ruleSummary ? ruleSummary + ' ' : ''}in Advanced Options, Do you want to continue?`;
}

	return (
		<Stack height="100%" spacing={2}>
			{/* Left Side: Stepper */}
			<Stack height={'100px'} width={'92%'} sx={{ display: 'flex', padding: '0px 15px 18px 15px' }}>
				<Stepper
					sx={theme => ({
						flex: 1,
						'& .MuiStepConnector-line': {
							borderTop: `2px solid ${theme.palette.secondary.orange || theme.palette.primary.light_shade}`,
							position: 'absolute',
							top: '50%',
							transform: 'translateY(-50%)',
							width: '100%',
						},
						'& .MuiStepConnector-root': {
							position: 'relative',
						},
					})}
					activeStep={activeIndex}
					orientation="horizontal"
				>
					{steps.map((step, index) => {
						const labelProps = {
							optional: null,
						};

						return (
							<Step key={step.label}>
								<StepLabel
									{...labelProps}
									onClick={() => handleStep(index)}
									StepIconComponent={CustomStepComponent}

									// optional={
									// 	index === activeIndex && (
									// 		<Typography
									// 			variant="caption"
									// 			color={AppColors.TEXT_DARK4}
									// 		>
									// 			{step.description}
									// 		</Typography>
									// 	)
									// }
								>
									<Typography
										sx={(theme) => ({
											color: index <= activeIndex ? (theme.palette.secondary.orange || theme.palette.primary.primary_shade) :( AppColors?.grey_text || AppColors.LIGHT_GRAY),
										})}
										fontSize={12}
										fontWeight={600}
										fontFamily={'Poppins'}
										lineHeight={'121%'}
									>
										{step.label}
									</Typography>
								</StepLabel>
								<StepContent {...labelProps}>
									<Typography
										variant="caption"
										color={AppColors?.midnight_black || AppColors.TEXT_DARK4}
										fontSize={10}
										fontWeight={400}
										sx={{ position: 'absolute', width: '150px' }}
									>
										{step.description}
									</Typography>
								</StepContent>
							</Step>
						);
					})}
				</Stepper>
			</Stack>

			<Divider sx={{ border: `1px solid ${AppColors.LIGHT2}`, width: '100%' }} />

			<Box sx={{ padding: '0px 20px 0px 20px' }}>
				<Stack
					sx={{
						// border: `1px solid red`,
						backgroundColor: AppColors.WHITE,
						position: 'relative',
						borderRadius: '15px',
					}}
				>
					<Stack
						sx={{
							// maxHeight: 'calc(100vh - 200px)',
							// maxHeight: 'calc(100vh - 280px)',
							height: 'calc(100vh - 295px)',
							overflowY: 'scroll',
							paddingBottom: '10px',
						}}
					>
						{/* <div style={{ height: '440px', overflowY: 'auto' }}> */}
						{steps?.map(({ Component, props }, index) => {
							return (
								activeIndex === index && (
									<Component key={index} {...props} details={details} setDetails={setDetails} setIsDialogOpenCheckData={setIsDialogOpenCheckData} assistants={assistants} exitInterView={isCampaignTypeExitInterview} />
								)
							);
						})}
						{/* </div> */}
					</Stack>

					<Stack
						p={2}
						borderTop={`1px solid ${AppColors.BORDER_GREY}`}
						direction="row"
						justifyContent={'center'}
						gap={2}
						sx={{
							position: 'sticky',
							width: '100%',
							left: 0,
							bottom: 0,
							bgcolor: AppColors.WHITE,
							borderRadius: '0 0 12px 12px',
						}}
					>
						<Button
							variant="outlined"
							type="default"
							sx={{ width: { sm: '160px', md: '275px' }, borderRadius: '2px' }}
							onClick={handlePrev}
						>
							{activeIndex == 0 ? 'Cancel' : 'Back'}
						</Button>

						<Button
							variant="outlined"
							disabled={isDisabledDraft() || loading}
							// loading={loading}
							type="default"
							sx={{ width: { sm: '160px', md: '275px' }, borderRadius: '2px' }}
							onClick={() => {
								handleDraft(true);
							}}
						>
							Save as Draft
						</Button>

						{/* <Button disabled={isDisabled()} loading={loading} type="primary" style={{ flex: 1 }} onClick={handleNext}> */}
						<Button
							loading={loading}
							disabled={loading}
							variant="contained"
							color='info'
							type="primary"
							sx={theme => ({ width: { sm: '160px', md: '275px' },
								 borderRadius: '2px',
								//   backgroundColor: theme.palette.primary.primary_shade 
								})}
							onClick={handleNext}
						>
							{activeIndex == steps.length - 1 ? 'Launch' : 'Next'}
						</Button>
					</Stack>
				</Stack>
			</Box>

			<ConfirmationDialog
                                            open={isDialogOpen}
                                            onClose={() =>{ setIsDialogOpen(false); }}
                                            onConfirm={() => {
                                                // Handle confirmation logic here
												setIsDialogOpen(false);
												setIsDialogOpenCheckData(null);
												handleStep(isDialogOpen - 1);
                                            }}
                                            title="Are you sure?"
                                              subTitle={buildRuleSubtitle(isDialogOpenCheckData || {})}

                                            cancelText="Cancel"
                                            confirmText="Next"
                                        />
		</Stack>
	);
}
